// extracted by mini-css-extract-plugin
module.exports = {"block":"ApplyJobBlock-module--block--52ZCn","title":"ApplyJobBlock-module--title--wvt14","text":"ApplyJobBlock-module--text--30ZUw"};